import { C as CosmosIconWarning$1, d as defineCustomElement$1 } from './p-ODoCtssu.js';

const CosmosIconWarning = CosmosIconWarning$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWarning, defineCustomElement };
